export const DEFAULT_MODERATION_LINK = 'https://images.cdn-cian.ru/imgmobile/builders/reviews/moderation.pdf';
